import type { CmsImageProps } from '@maestro/commerce-blocks/components/cms-image/cms-image.types'

import classNames from 'classnames'
import { preload } from 'react-dom'

import '@maestro/commerce-blocks/components/cms-image/styles/cms-image.scss'

export default function CmsImage(props: CmsImageProps) {
  const {
    image,
    hideOnMobile,
    className: customClassName,
    preload: shouldPreload,
    alt,
    fetchPriority,
    ...rest
  } = props

  if (!image) {
    return null
  }

  if (shouldPreload) {
    preload(image.mobile.src, {
      as: 'image',
      media: '(max-width: 767px)',
      fetchPriority,
      imageSrcSet: image.mobile.srcSet ?? image.mobile.src,
      imageSizes: image.mobile.sizes,
    })
    preload(image.desktop.src, {
      as: 'image',
      media: '(min-width: 768px)',
      fetchPriority,
      imageSrcSet: image.desktop.srcSet,
      imageSizes: image.desktop.sizes,
    })
  }

  return (
    <picture
      className={classNames('cms-image-wrapper', {
        'mobile-hidden': hideOnMobile,
      })}
    >
      <source
        media="(max-width: 767px)"
        srcSet={image.mobile.srcSet ?? image.mobile.src}
        sizes={image.mobile.sizes}
        width={image.mobile.width}
        height={image.mobile.height}
      />
      <img
        src={image.desktop.src}
        srcSet={image.desktop.srcSet}
        sizes={image.desktop.sizes}
        alt={alt}
        width={image.desktop.width}
        height={image.desktop.height}
        className={classNames(
          'cms-image',
          { 'cms-image--placeholder': image.isPlaceholder },
          customClassName
        )}
        decoding="async"
        fetchPriority={fetchPriority}
        {...rest}
      />
    </picture>
  )
}
